import { GameSizeMetrics } from 'src/games/common/phaser/game/scenes/scaled-base-scene';

type GameLayoutConfig = {
  pileWidth: number;
  pileHeight: number;
  hPadding: number;
  hSpacing: number;
  vPadding: number;
  vSpacing: number;
  stackSpacing: number;
};

export class GameMetricsService {
  public readonly gameLayoutConfig: GameLayoutConfig = {
    pileWidth: 256,
    pileHeight: 384,
    hPadding: 100,
    hSpacing: 30,
    vPadding: 150,
    vSpacing: 200,
    stackSpacing: 90,
  };

  public calculateBoardScaling(gameSizeMetrics: GameSizeMetrics): {
    totalWidth: number;
    scaleFactor: number;
  } {
    const layoutConfig = this.gameLayoutConfig;
    const totalWidth = layoutConfig.pileWidth * 7 + layoutConfig.hSpacing * 6;
    return {
      totalWidth: totalWidth,
      scaleFactor: gameSizeMetrics.widthDpr / (totalWidth + layoutConfig.hPadding * 2),
    };
  }
}
